import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './utils/styles/main.scss';

ReactDOM.render(<App />, document.getElementById('root'));
